import api from './api'

export default {
  api,
  data: () => {},
  models: () => {},
}
